module.exports = __webpack_public_path__ + "static/champ_bg-33e6b9eebfcc5562a61ba00c7687a42b.jpg";